
/*
Un manager de alertas
*/
(function alertsModuleDefinition() {

    angular.module('Alerts', ['ui.bootstrap.modal']);

})();